import {ChangeDetectionStrategy, Component, EventEmitter, Inject, Output} from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as fromShared from '../../../reducers';
import {Observable} from 'rxjs';
import {PlayerConfigurationDefinition} from '../../../models/player-config-list-option';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-add-options',
  templateUrl: './add-options.component.html',
  styleUrls: ['./add-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddOptionsComponent  {
  @Output() addOptionItem = new EventEmitter<PlayerConfigurationDefinition>();
  playerConfigDef$: Observable<PlayerConfigurationDefinition[]>;
  query: string;
  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, private store: Store<fromShared.AppState>) {
    this.playerConfigDef$ = this.store.pipe(select(fromShared.selectors.getPlayerConfigDef));
  }

  addItem(item: PlayerConfigurationDefinition): void {
    this.addOptionItem.emit(item);
  }
}
